import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const RoleBasedHeader = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Use database userType first, fallback to attributes
  const userType = user?.userType || user?.attributes?.['custom:user_type'] || 'client';
  const vendorId = user?.currentVendorId;

  // Client Navigation
  const clientTabs = [
    { id: 'dashboard', label: 'Dashboard', path: '/dashboard' },
    { id: 'checklist', label: 'Checklist', path: '/checklist' },
    { id: 'budget', label: 'Budget', path: '/budget' },
    { id: 'vendors', label: 'Vendors', path: '/vendors' },
    { id: 'guests', label: 'Guests', path: '/guests' }
  ];

  // Venue Manager Navigation
  const venueTabs = [
    { id: 'events', label: 'Events', path: '/venue/events' },
    { id: 'event-details', label: 'Event Details', path: '/venue/event-details' },
    { id: 'tasks', label: 'Tasks', path: '/venue/tasks' },
    { id: 'clients', label: 'Clients', path: '/venue/clients' }
  ];

  // Service Vendor Navigation
  const vendorTabs = [
    { id: 'events', label: 'My Events', path: '/vendor/events' },
    { id: 'tasks', label: 'Tasks', path: '/vendor/tasks' },
    { id: 'documents', label: 'Documents', path: '/vendor/documents' }
  ];

  // Select tabs based on user type and vendor association
  let tabs = clientTabs;
  if (userType === 'vendor' && vendorId) {
    tabs = venueTabs; // Venue manager (has currentVendorId)
  } else if (userType === 'vendor' && !vendorId) {
    tabs = vendorTabs; // Service vendor (no currentVendorId)
  }

  const getActiveTab = () => {
    const currentPath = location.pathname;
    // Don't show any tab as active if on messages page
    if (currentPath === '/messages' || currentPath === '/threads' || currentPath === '/vendor/messages') return null;
    // Don't show any tab as active if on vendor dashboard
    if (currentPath === '/vendor/dashboard') return null;
    // Highlight Vendors tab if on vendor detail page
    if (currentPath.startsWith('/vendors/')) return 'vendors';
    const tab = tabs.find(t => t.path === currentPath);
    return tab ? tab.id : null;
  };

  const handleTabClick = (tab) => {
    navigate(tab.path);
  };

  return (
    <header style={{
      backgroundColor: 'white',
      borderBottom: '1px solid #e2e8f0',
      padding: '0 24px'
    }}>
      <div className="header-nav" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '64px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <img 
            src="/everset-logo.svg" 
            alt="Everset" 
            style={{ height: '24px', width: 'auto' }}
          />
          {userType === 'vendor' && (
            <span style={{ 
              fontSize: '14px', 
              color: '#6B7280',
              backgroundColor: '#F3F4F6',
              padding: '4px 8px',
              borderRadius: '4px'
            }}>
              {vendorId ? 'Venue Manager' : 'Service Vendor'}
            </span>
          )}
        </div>

        <nav className="header-tabs" style={{ display: 'flex', gap: '32px' }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab)}
              className="header-tab"
              style={{
                padding: '16px 0',
                backgroundColor: 'transparent',
                border: 'none',
                borderBottom: getActiveTab() === tab.id ? '2px solid #6B9080' : '2px solid transparent',
                color: getActiveTab() === tab.id ? '#6B9080' : '#64748b',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button 
            onClick={() => {
              if (userType === 'vendor' && vendorId) {
                navigate('/vendor/messages');
              } else {
                navigate('/messages');
              }
            }}
            style={{
            width: '40px',
            height: '40px',
            border: 'none',
            backgroundColor: (location.pathname === '/messages' || location.pathname === '/vendor/messages') ? '#E8F4E8' : 'transparent',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            borderRadius: '8px'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={(location.pathname === '/messages' || location.pathname === '/vendor/messages') ? '#6B9080' : '#6B9080'} strokeWidth="1.5">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
            </svg>
            <span style={{
              position: 'absolute',
              top: '2px',
              right: '2px',
              backgroundColor: '#EF4444',
              color: 'white',
              borderRadius: '50%',
              width: '16px',
              height: '16px',
              fontSize: '10px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              1
            </span>
          </button>
          
          <button 
            onClick={onLogout}
            style={{
            width: '40px',
            height: '40px',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6B9080" strokeWidth="1.5">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16,17 21,12 16,7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default RoleBasedHeader;